import axios, { AxiosError, AxiosResponse } from "axios";

import { getAPIUrl } from 'src/config';
import IAgent from "src/ServerEntities/IAgent";
import IAgentMetric from "src/ServerEntities/IAgentMetric";
import IErrorDetails from "src/ServerEntities/IErrorDetails";
import { NETWORK_ERROR } from 'src/UsefulFunctions/createErrorMessage';

const handleError = (error: AxiosError<IErrorDetails>, failureCallback: (errorMessage: string) => void) => {
    let errorMessage = "Unknown error";
    if (error.response) {
        errorMessage = error.response.data.message;
        if (error.response.status === 401 && error.response.data.message === undefined) {
            errorMessage = "Unauthorised to perform this request.";
        }
    }
    if (error.message === "Network Error") {
        errorMessage = NETWORK_ERROR;
    }
    failureCallback(errorMessage as string);
};

export const createAgent = (webToken: string, agent: Omit<IAgent, "id" | "status">, successCallback: () => void, failureCallback: (errorMessage: string) => void) => {
    axios.post(
        `${getAPIUrl()}agents/`,
        agent,
        { headers: { Authorization: `Bearer ${webToken}` } }
    )
        .then((_response: AxiosResponse<any>) => {
            successCallback();
        })
        .catch((error: AxiosError<IErrorDetails>) => {
            handleError(error, failureCallback);
        });
};

export const deleteAgent = (agentId: number, webToken: string, successCallback: () => void, failureCallback: (errorMessage: string) => void) => {
    axios.delete(
        `${getAPIUrl()}agents/${agentId}`,
        { headers: { Authorization: `Bearer ${webToken}` } }
    )
        .then((_response: AxiosResponse<any>) => {
            successCallback();
        })
        .catch((error: AxiosError<IErrorDetails>) => {
            handleError(error, failureCallback);
        });
};

export const enableAgent = (agentId: number, webToken: string, successCallback: () => void, failureCallback: (errorMessage: string) => void) => {
    axios.get(
        `${getAPIUrl()}agents/${agentId}/enable`,     
        { headers: { Authorization: `Bearer ${webToken}` } }
    )
        .then((_response: AxiosResponse<any>) => {
            successCallback();
        })
        .catch((error: AxiosError<IErrorDetails>) => {
            handleError(error, failureCallback);
        });
};

export const disableAgent = (agentId: number, webToken: string, successCallback: () => void, failureCallback: (errorMessage: string) => void) => {
    axios.get(
        `${getAPIUrl()}agents/${agentId}/disable`,
        { headers: { Authorization: `Bearer ${webToken}` } }
    )
        .then((_response: AxiosResponse<any>) => {
            successCallback();
        })
        .catch((error: AxiosError<IErrorDetails>) => {
            handleError(error, failureCallback);
        });
};

export const getAgentMetrics = (agentId: number, webToken: string, successCallback: (metrics: IAgentMetric[]) => void, failureCallback: (errorMessage: string) => void) => {
    axios.get(
        `${getAPIUrl()}agents/${agentId}/metrics`,
        { headers: { Authorization: `Bearer ${webToken}` } }
    )
        .then((response: AxiosResponse<IAgentMetric[]>) => {
            successCallback(response.data);
        })
        .catch((error: AxiosError<IErrorDetails>) => {
            handleError(error, failureCallback);
        });
};
